import { Divider } from '@mantine/core';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type DividerType = BaseField & {
  type: 'Divider';
};

function DividerElement({ field }: StaticFieldProps<DividerType>) {
  return <Divider my="xs" label={field.label} labelPosition="center" />;
}

const Descriptor: FieldDescriptor<DividerType> = {
  FieldComponent: DividerElement,
  name: 'Divider',
};

export default Descriptor;
